module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select5.fb06c305.png";